<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>Programmes</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Programmes</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section>
    <div class="container">

        <table class="table table-responsive table-stripped table-bordered" id="gvcourse">
            <thead>
            <tr >
                <th class="bg-secondary text-white">School</th>
                <th class="bg-secondary text-white">Department</th>
                <th class="bg-secondary text-white">Course_Type</th>
                <th class="bg-secondary text-white">Course</th>
                <th class="bg-secondary text-white">Duration</th>
            </tr>
            </thead>
            <tbody style="background: aliceblue;color:#e67e22; font-weight: bold;">
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">Mechanical Engineering</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">B.Tech(ME)</td>
                <td class=" tx-medium tx-danger">4 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">Civil Engineering</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">B.Tech(Civil)</td>
                <td class=" tx-medium tx-danger">4 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">Computer Science Engineering</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">B.Tech(CS)</td>
                <td class=" tx-medium tx-danger">4 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Business Management &amp; Commerce</td>
                <td class=" tx-medium tx-inverse">BusinessStudies</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BBA</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">Computer Science &amp; Applicaton</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BCA</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Business Management &amp; Commerce</td>
                <td class=" tx-medium tx-inverse">Commerce</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">B.Com</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Journalism &amp; Mass Communication</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BA</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Basic Sciences &amp; Bio-Technology</td>
                <td class=" tx-medium tx-inverse">Life Science</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BSC Medical</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Basic Sciences &amp; Bio-Technology</td>
                <td class=" tx-medium tx-inverse">Physics</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BSC (Non-Medical)</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Agriculture</td>
                <td class=" tx-medium tx-inverse">Agriculture</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BSC (Agriculture)</td>
                <td class=" tx-medium tx-danger">4 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Hotel Management &amp; Tourism</td>
                <td class=" tx-medium tx-inverse">Hotel &amp; Tourism</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BHMCT</td>
                <td class=" tx-medium tx-danger">4 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Journalism &amp; Mass Communication</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BA (Journalism and Mass Communication)</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Pharmacy</td>
                <td class=" tx-medium tx-inverse">Pharmacy</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">B.Pharmacy</td>
                <td class=" tx-medium tx-danger">4 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Design</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">Bachelor&nbsp;of&nbsp;Fashion Design</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">Computer Science Engineering</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">M.Tech(CS)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">Civil Engineering</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">M.Tech(Civil)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">Mechanical Engineering</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">M.Tech(ME)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Business Management &amp; Commerce</td>
                <td class=" tx-medium tx-inverse">Commerce</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">M.com</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">English</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">MA(Eng)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Education</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">MA (Economics)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Journalism &amp; Mass Communication</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">MA (Journalism &amp; Mass Communication)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Basic Sciences &amp; Bio-Technology</td>
                <td class=" tx-medium tx-inverse">Maths</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">Msc (Math)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Basic Sciences &amp; Bio-Technology</td>
                <td class=" tx-medium tx-inverse">Physics</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">Msc(Physics)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Basic Sciences &amp; Bio-Technology</td>
                <td class=" tx-medium tx-inverse">Chemistry</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">Msc(Chemistry)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Basic Sciences &amp; Bio-Technology</td>
                <td class=" tx-medium tx-inverse">Life Science</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">Msc(Botany)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Basic Sciences &amp; Bio-Technology</td>
                <td class=" tx-medium tx-inverse">Life Science</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">Msc(Zoology)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Business Management &amp; Commerce</td>
                <td class=" tx-medium tx-inverse">BusinessStudies</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">MBA</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">Computer Science &amp; Applicaton</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">MCA</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Pharmacy</td>
                <td class=" tx-medium tx-inverse">Pharmacy</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">D.Pharmacy</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">Computer Science Engineering</td>
                <td class=" tx-medium tx-inverse">Doctorate</td>
                <td class=" tx-medium tx-inverse">Ph.D CSE</td>
                <td class=" tx-medium tx-danger">5 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">Mechanical Engineering</td>
                <td class=" tx-medium tx-inverse">Doctorate</td>
                <td class=" tx-medium tx-inverse">Ph.D Mechanical</td>
                <td class=" tx-medium tx-danger">5 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">Civil Engineering</td>
                <td class=" tx-medium tx-inverse">Doctorate</td>
                <td class=" tx-medium tx-inverse">Ph.D Civil</td>
                <td class=" tx-medium tx-danger">5 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Law</td>
                <td class=" tx-medium tx-inverse">Legal Studies</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">LL.B</td>
                <td class=" tx-medium tx-danger">5 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Business Management &amp; Commerce</td>
                <td class=" tx-medium tx-inverse">BusinessStudies</td>
                <td class=" tx-medium tx-inverse">Doctorate</td>
                <td class=" tx-medium tx-inverse">Ph.D Management</td>
                <td class=" tx-medium tx-danger">5 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">Computer Science &amp; Applicaton</td>
                <td class=" tx-medium tx-inverse">Integrated UG &amp; PG</td>
                <td class=" tx-medium tx-inverse">Integrated Program-BCA &amp; MCA</td>
                <td class=" tx-medium tx-danger">5 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">Computer Science &amp; Applicaton</td>
                <td class=" tx-medium tx-inverse">Doctorate</td>
                <td class=" tx-medium tx-inverse">Ph.D Computer Application</td>
                <td class=" tx-medium tx-danger">5 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">English</td>
                <td class=" tx-medium tx-inverse">Doctorate</td>
                <td class=" tx-medium tx-inverse">Ph.D English</td>
                <td class=" tx-medium tx-danger">5 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Journalism &amp; Mass Communication</td>
                <td class=" tx-medium tx-inverse">Doctorate</td>
                <td class=" tx-medium tx-inverse">Ph.D Mass Communication</td>
                <td class=" tx-medium tx-danger">5 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Library Science</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">B.Lib</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Library Science</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">M.Lib</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Law</td>
                <td class=" tx-medium tx-inverse">Legal Studies</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BA. LL.B</td>
                <td class=" tx-medium tx-danger">5 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">ECE &amp; EE</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">B.Tech(ECE)</td>
                <td class=" tx-medium tx-danger">4 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">ECE &amp; EE</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">B.Tech(EE)</td>
                <td class=" tx-medium tx-danger">4 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">ECE &amp; EE</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">Diploma (EE)</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Law</td>
                <td class=" tx-medium tx-inverse">Legal Studies</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">LLM</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">English</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BA(Hons)Eng</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Yoga Science</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BA(Yoga)</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Yoga Science</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">B.SC(Yoga)</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Business Management &amp; Commerce</td>
                <td class=" tx-medium tx-inverse">BusinessStudies</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BBA (Specialization)</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Business Management &amp; Commerce</td>
                <td class=" tx-medium tx-inverse">BusinessStudies</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">MBA (Retail Management)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Business Management &amp; Commerce</td>
                <td class=" tx-medium tx-inverse">BusinessStudies</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">Risk Reduction and Management</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Business Management &amp; Commerce</td>
                <td class=" tx-medium tx-inverse">BusinessStudies</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">Diploma in Direct Selling</td>
                <td class=" tx-medium tx-danger">1 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Business Management &amp; Commerce</td>
                <td class=" tx-medium tx-inverse">BusinessStudies</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">Diploma on Disaster Risk Reduction and Management</td>
                <td class=" tx-medium tx-danger">1 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Hotel Management &amp; Tourism</td>
                <td class=" tx-medium tx-inverse">Hotel &amp; Tourism</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">Bachelor of Science (Culinary Arts)</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Hotel Management &amp; Tourism</td>
                <td class=" tx-medium tx-inverse">Hotel &amp; Tourism</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">Bachelor of Science (Hospitality &amp; Culinary Management)</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Hotel Management &amp; Tourism</td>
                <td class=" tx-medium tx-inverse">Hotel &amp; Tourism</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">Bachelor of Science (Hospitality &amp; Hotel Administration)</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Business Management &amp; Commerce</td>
                <td class=" tx-medium tx-inverse">Hospitality Management</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">MBA (Hospital Management)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Business Management &amp; Commerce</td>
                <td class=" tx-medium tx-inverse">Hospitality Management</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">MBA (Pharmaceutical Management)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">Cyber Security &amp; AI</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">Diploma in Artifical Intelligence and Machine Learning</td>
                <td class=" tx-medium tx-danger">1 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Technology</td>
                <td class=" tx-medium tx-inverse">Cyber Security &amp; AI</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">Diploma in Forensic Science &amp; Cyber Security</td>
                <td class=" tx-medium tx-danger">1 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Education &amp; Sports</td>
                <td class=" tx-medium tx-inverse">Sports</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BPES</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Business Management &amp; Commerce</td>
                <td class=" tx-medium tx-inverse">BusinessStudies</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">Diploma in Event Management</td>
                <td class=" tx-medium tx-danger">1 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Business Management &amp; Commerce</td>
                <td class=" tx-medium tx-inverse">BusinessStudies</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">Diploma in Digital Marketing</td>
                <td class=" tx-medium tx-danger">1 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Allied Health Sciences</td>
                <td class=" tx-medium tx-inverse">Naturopathy &amp; Yogic Sciences</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BNYS</td>
                <td class=" tx-medium tx-danger">5 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Allied Health Sciences</td>
                <td class=" tx-medium tx-inverse">Naturopathy &amp; Yogic Sciences</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">2.5 Years</td>
                <td class=" tx-medium tx-danger">3.5 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Yoga Science</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">Diploma in Panchkarma</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Education</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">MA (Geography)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Education</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">MA (Hindi)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Education</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">MA (History)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Education</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">MA (Philosophy)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Education</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">MA (Psychology)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Education</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">MA (Public Administration)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Education</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">MA (Sociology)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Vocational Courses</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">Multimedia</td>
                <td class=" tx-medium tx-danger">1 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Vocational Courses</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">Animation</td>
                <td class=" tx-medium tx-danger">1 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Vocational Courses</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">Digital Photography</td>
                <td class=" tx-medium tx-danger">1 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Vocational Courses</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">Digital marketing</td>
                <td class=" tx-medium tx-danger">1 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Vocational Courses</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">Digital Film Making</td>
                <td class=" tx-medium tx-danger">1 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Vocational Courses</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">Graphics Designing</td>
                <td class=" tx-medium tx-danger">1 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Basic Sciences &amp; Bio-Technology</td>
                <td class=" tx-medium tx-inverse">Life Science</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BSC Microbiology</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Basic Sciences &amp; Bio-Technology</td>
                <td class=" tx-medium tx-inverse">Life Science</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BSC Zoology</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Basic Sciences &amp; Bio-Technology</td>
                <td class=" tx-medium tx-inverse">Life Science</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BSC Botany</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Basic Sciences &amp; Bio-Technology</td>
                <td class=" tx-medium tx-inverse">Life Science</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BSC Forensic Science</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Allied Health Sciences</td>
                <td class=" tx-medium tx-inverse">Anesthesia</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BSC (Anesthesia)</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Allied Health Sciences</td>
                <td class=" tx-medium tx-inverse">Medical Lab Technology</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BMLT</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Allied Health Sciences</td>
                <td class=" tx-medium tx-inverse">Radiology</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BSC (MRIT)</td>
                <td class=" tx-medium tx-danger">4 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Allied Health Sciences</td>
                <td class=" tx-medium tx-inverse">Operation Theatre Technology</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BSC (OTT)</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Allied Health Sciences</td>
                <td class=" tx-medium tx-inverse">Optometry</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BSC (Optometry)</td>
                <td class=" tx-medium tx-danger">4 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Allied Health Sciences</td>
                <td class=" tx-medium tx-inverse">Physiotherapy</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">BSC (Physiotherapy)</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Design</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">Diploma in Fashion Designing</td>
                <td class=" tx-medium tx-danger">1 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Design</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">B.Des (Fashion)</td>
                <td class=" tx-medium tx-danger">4 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Design</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">M.Des (Fashion Design)</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Design</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">Diploma in Interior Designing</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Design</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">Bachelor of Interior Design</td>
                <td class=" tx-medium tx-danger">3 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Design</td>
                <td class=" tx-medium tx-inverse">Under Graduate</td>
                <td class=" tx-medium tx-inverse">B.Des (Interior Design)</td>
                <td class=" tx-medium tx-danger">4 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Design</td>
                <td class=" tx-medium tx-inverse">Post Graduate</td>
                <td class=" tx-medium tx-inverse">Master in Interior Designing</td>
                <td class=" tx-medium tx-danger">2 Years</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">Arni School of Arts &amp; Humanities</td>
                <td class=" tx-medium tx-inverse">Journalism &amp; Mass Communication</td>
                <td class=" tx-medium tx-inverse">Diploma</td>
                <td class=" tx-medium tx-inverse">Diploma in Mass communication</td>
                <td class=" tx-medium tx-danger">1 Years</td>
            </tr>
            </tbody>
        </table>

    </div>
</section>
